/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */

import { Component } from 'react';
import toJS from 'transmute/toJS';
import valueSeq from 'transmute/valueSeq';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Url from 'urlinator/Url';
import Raven from 'raven-js';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import BookingContainerV2 from './page/BookingContainerV2';
import CancelContainer from './page/CancelContainer';
import BookingSummary from './page/BookingSummary';
import Error from 'MeetingsLib/components/Error';
import PaymentError from 'MeetingsLib/components/payments/PaymentError';
import { setDocumentTitle } from 'MeetingsLib/utils/utils';
import { trackHsFormViews, trackLibVersion } from 'MeetingsLib/utils/analytics';
import hubspotGTMContainer from 'MeetingsLib/utils/hubspotGTMContainer';
import webflowContainer from 'MeetingsLib/utils/webflowContainer';
import { initializeMeetingsLibTracker } from 'MeetingsLib/tracking/UsageTracker';
import { getBookInfoError as getBookInfoErrorSelector, isInvalidDomainError as isInvalidDomainErrorSelector, getRescheduleError as getRescheduleErrorSelector } from 'MeetingsLib/selectors/NetworkErrorSelector';
import { meetingCreationSuccess as meetingCreationSuccessSelector, bookingPageLoading as bookingPageLoadingSelector, shouldRenderBookingPage as shouldRenderBookingPageSelector, fetchBookInfoFailed as fetchBookInfoFailedSelector, meetingCreationFailed as meetingCreationFailedSelector, availabilityFetchFailed as availabilityFetchFailedSelector, availabilityFetchSuccess as availabilityFetchSuccessSelector, meetingsUserFetchStarted as meetingsUserFetchStartedSelector, meetingsUserFetchSuccess as meetingsUserFetchSuccessSelector, isSubmittingMeeting as isSubmittingMeetingSelector, meetingRescheduleSuccess as meetingRescheduleSuccessSelector, meetingRescheduleFailed as meetingRescheduleFailedSelector } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { getCustomParams as getCustomParamsSelector, getUserProfile as getUserProfileSelector, getDisplayInfo as getDisplayInfoSelector, getWelcomeScreenInfo as getWelcomeScreenInfoSelector, getBookInfo as getBookInfoSelector, getOffline as getOfflineSelector, getPaidMeetingsAvailableSelector, getPaymentLinkInfo, getIsUngatedForFullTrackingScript } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getPaidMeetingPrice } from 'MeetingsLib/selectors/PaymentStatusSelectors';
import { getActiveLocale } from 'MeetingsLib/selectors/LocalizationSelectors';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import * as BookActions from 'MeetingsLib/redux/actions/BookActions';
import * as AvailabilityActions from 'MeetingsLib/redux/actions/AvailabilityActions';
import * as UIActions from 'MeetingsLib/redux/actions/UIActions';
import Branding from 'MeetingsBase/models/Branding';
import UserProfile from 'MeetingsBase/models/UserProfile';
import DisplayInfo from 'MeetingsBase/models/DisplayInfo';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import { LINK_TYPES } from 'MeetingsBase/constants/enums';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
import { LEGACY_MEETING_CHANGE_ID_PARAM, LEGACY_CANCEL_PARAM, CANCEL_PARAM } from 'MeetingsLib/constants/tracking';
import withConsentListeners from 'MeetingsLib/components/hoc/withConsentListeners';
import withWindowListeners from 'MeetingsLib/components/hoc/withWindowListeners';
import Compliance from 'MeetingsLib/components/internalCompliance/Compliance';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class App extends Component {
  constructor(props) {
    super(props);
    this.shouldSetDocumentTitle = (availabilityFetchSuccess, embedded) => {
      const meetingsLinkExists = availabilityFetchSuccess;
      return !embedded && meetingsLinkExists;
    };
    this.shouldTrackFormViews = (previousFormGuid, nextFormGuid) => {
      return previousFormGuid !== nextFormGuid && nextFormGuid;
    };
    this.setContainerNodeRef = elem => {
      this.containerNodeRef = elem;
    };
    this.handleResizeIframe = () => {
      if (this.props.embedded && this.containerNodeRef) {
        const height = this.getNextIframeHeight();
        parent.postMessage({
          height
        }, '*');
      }
    };
    this.getNextIframeHeight = () => {
      /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
      return this.containerNodeRef.getBoundingClientRect().height + 25;
    };
    this.isCancelPage = () => {
      const {
        embedded
      } = this.props;
      const url = new Url(window.location);
      const oldCancelParam = url.paramValue(LEGACY_CANCEL_PARAM) === 'true';
      const hasCancelParam = url.paramValue(CANCEL_PARAM) || oldCancelParam;
      const oldMeetingChangeId = url.paramValue(LEGACY_MEETING_CHANGE_ID_PARAM);
      const hasMeetingChangeId = hasCancelParam || oldMeetingChangeId;
      return !embedded && hasCancelParam && !!hasMeetingChangeId;
    };
    this.renderBookingContainer = () => {
      const {
        branding,
        hideLogo,
        profile,
        submittingMeeting,
        displayInfo: {
          avatar,
          headline,
          publicDisplayAvatarOption,
          companyAvatar
        },
        welcomeScreenInfo,
        DatePickerMarker,
        TimePickerMarker,
        EmailFormMarker,
        compact
      } = this.props;
      return /*#__PURE__*/_jsx(BookingContainerV2
      /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */, {
        avatar: avatar
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        companyAvatar: companyAvatar
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        displayAvatarOption: publicDisplayAvatarOption,
        branding: branding
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        headline: headline,
        hideLogo: hideLogo,
        isPreviewed: false,
        profile: profile,
        submittingMeeting: submittingMeeting,
        welcomeScreenInfo: welcomeScreenInfo,
        DatePickerMarker: DatePickerMarker,
        TimePickerMarker: TimePickerMarker,
        EmailFormMarker: EmailFormMarker,
        compact: compact,
        setContainerNodeRef: this.setContainerNodeRef
      });
    };
    this.renderSummary = () => {
      const {
        bookingLifecycle,
        branding,
        embedded,
        isSalesStarter,
        offline,
        profile,
        userTimezone,
        redirectUrl,
        allowRedirect,
        portalId,
        isPaidMeeting,
        paidMeetingInfo,
        paidMeetingPrice,
        compact,
        linkType,
        userSlug,
        formGuid
      } = this.props;
      /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
      const bookedDateTime = bookingLifecycle.postResponse.get('timerange').start;
      /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
      const bookedOffline = bookingLifecycle.postResponse.get('bookedOffline');
      return /*#__PURE__*/_jsx(BookingSummary, {
        bookedDateTime: bookedDateTime,
        branding: branding,
        embedded: embedded,
        isSalesStarter: isSalesStarter,
        isPaidMeeting: isPaidMeeting,
        isPreviewed: false,
        paidMeetingInfo: paidMeetingInfo,
        paidMeetingPrice: paidMeetingPrice,
        offline: offline || bookedOffline,
        profile: profile,
        userTimezone: userTimezone,
        redirectUrl: redirectUrl,
        allowRedirect: allowRedirect,
        onSuccess: () => {
          const meetingsPayload = {
            linkType,
            offline,
            userSlug,
            formGuid,
            bookingResponse: bookingLifecycle && bookingLifecycle.toJS(),
            isPaidMeeting
          };
          parent.postMessage({
            meetingBookSucceeded: true,
            meetingsPayload
          }, '*');
          this.props.onSuccess(toJS(bookingLifecycle.postResponse));
        },
        portalId: portalId,
        compact: compact
      });
    };
    this.renderError = profile => {
      const {
        bookingLifecycle,
        fetchBookInfoFailed,
        meetingsUserFetchSuccess,
        meetingCreationFailed,
        meetingRescheduleFailed,
        bookInfoError,
        NotFoundMarker,
        meetingRescheduleError,
        ErrorMarker,
        isPaidMeeting,
        paidMeetingInfo,
        compact,
        linkType,
        offline,
        userSlug,
        formGuid
      } = this.props;
      const ErrorComponent = isPaidMeeting ? PaymentError : Error;
      return /*#__PURE__*/_jsx(ErrorComponent, {
        profile: profile,
        compact: compact,
        bookInfoError: bookInfoError,
        meetingCreationFailed: meetingCreationFailed,
        meetingRescheduleFailed: meetingRescheduleFailed,
        meetingRescheduleError: meetingRescheduleError,
        bookInfoFailed: fetchBookInfoFailed,
        paidMeetingInfo: paidMeetingInfo,
        meetingsUserFetchSuccess: meetingsUserFetchSuccess,
        NotFoundMarker: NotFoundMarker,
        ErrorMarker: ErrorMarker,
        onFailure: () => {
          const meetingsPayload = {
            linkType,
            offline,
            userSlug,
            formGuid,
            bookingResponse: bookingLifecycle && bookingLifecycle.toJS(),
            isPaidMeeting
          };
          parent.postMessage({
            meetingBookFailed: true,
            meetingsPayload
          }, '*');
          this.props.onFailure(toJS(bookingLifecycle.postResponse));
        }
      });
    };
    this.renderApplication = () => {
      const {
        profile,
        bookingPageLoading,
        meetingsUserFetchStarted,
        shouldRenderBookingPage,
        meetingCreationSuccess,
        meetingRescheduleSuccess,
        availabilityFetchFailed,
        displayInfo,
        CancelMarker
      } = this.props;
      if (shouldRenderBookingPage && !availabilityFetchFailed) {
        if (this.isCancelPage()) {
          return /*#__PURE__*/_jsx(CancelContainer, {
            CancelMarker: CancelMarker,
            displayInfo: displayInfo,
            profile: profile
          });
        }
        return this.renderBookingContainer();
      }
      if (bookingPageLoading || meetingsUserFetchStarted) {
        return /*#__PURE__*/_jsx(LoadingSpinner, {
          layout: "centered",
          margin: "0",
          blockSize: "100%"
        });
      }
      if (meetingCreationSuccess || meetingRescheduleSuccess) {
        return this.renderSummary();
      }
      return this.renderError(profile);
    };
    this.containerNodeRef = null;
  }
  componentDidMount() {
    const {
      fetchEventDetails,
      userSlug,
      isRescheduling,
      meetingChangeId,
      getAvailability,
      changeLocale
    } = this.props;
    getAvailability(changeLocale);
    trackLibVersion();
    if (isRescheduling) {
      fetchEventDetails(userSlug, meetingChangeId);
    }
    this.handleResizeIframe();
  }
  componentDidUpdate(prevProps) {
    const {
      formGuid: previousFormGuid,
      initTrackingForMeetings,
      portalId: __oldPortalId,
      companyName: __oldCompanyName,
      availabilityFetchSuccess: oldAvailabilityFetchSuccess,
      linkType: __oldLinkType,
      contentTracking: __oldContentTracking,
      activeLocale: __activeLocale
    } = prevProps;
    const {
      profile,
      displayInfo: {
        headline
      },
      availabilityFetchSuccess,
      portalId,
      linkType,
      formGuid: nextFormGuid,
      contentTracking: nextContentTracking,
      embedded,
      companyName,
      activeLocale
    } = this.props;
    const availabilityInfoLoaded = availabilityFetchSuccess && availabilityFetchSuccess !== oldAvailabilityFetchSuccess;
    if (availabilityInfoLoaded) {
      hubspotGTMContainer(portalId);
      webflowContainer(portalId);
    }
    if (availabilityInfoLoaded && initTrackingForMeetings) {
      initializeMeetingsLibTracker(profile.email, portalId, embedded, activeLocale);
    }
    const shouldSetDocumentTitle = this.shouldSetDocumentTitle(availabilityFetchSuccess, embedded);
    if (shouldSetDocumentTitle) {
      /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
      setDocumentTitle(headline, linkType, companyName, profile);
    }
    const shouldTrackFormViews = this.shouldTrackFormViews(previousFormGuid, nextFormGuid);
    if (shouldTrackFormViews && availabilityFetchSuccess) {
      trackHsFormViews(nextFormGuid, portalId, Object.assign({}, prevProps.parentPageHSAnalyticsInfo, nextContentTracking), embedded);
    }
    const {
      availabilityFetchFailed: availabilityFetchDidFail,
      forceMobile: wasForceMobile
    } = prevProps;
    const {
      availabilityFetchFailed,
      bookInfoError,
      forceMobile
    } = this.props;
    if (!availabilityFetchDidFail && availabilityFetchFailed) {
      Raven.captureBreadcrumb({
        message: 'Public availability info fetch failed!',
        data: {
          error: bookInfoError
        }
      });
    }
    if (!wasForceMobile && forceMobile || embedded && this.containerNodeRef) {
      this.handleResizeIframe();
    }
  }
  render() {
    const {
      embedded,
      isPaidMeeting
    } = this.props;
    const className = classNames("meetings-lib page", embedded && "embedded", isPaidMeeting && "paid");
    /* @bend-expect trellis-tokenized keeping this to retain @media screen and (max-width: 632px) */
    return /*#__PURE__*/_jsxs("div", {
      className: className,
      children: [/*#__PURE__*/_jsx(Compliance, {}), this.renderApplication()]
    });
  }
}
App.propTypes = {
  // passable props
  branding: PropTypes.instanceOf(Branding).isRequired,
  displayInfo: PropTypes.instanceOf(DisplayInfo).isRequired,
  hideLogo: PropTypes.bool,
  changeLocale: PropTypes.func,
  DatePickerMarker: PropTypes.func,
  TimePickerMarker: PropTypes.func,
  EmailFormMarker: PropTypes.func,
  NotFoundMarker: PropTypes.func,
  ErrorMarker: PropTypes.func,
  CancelMarker: PropTypes.func,
  // props from store (don't change these)
  forceMobile: PropTypes.bool,
  bookInfoError: PropTypes.string,
  bookingLifecycle: PropTypes.instanceOf(BookingLifecycle).isRequired,
  companyName: PropTypes.string,
  embedded: PropTypes.bool.isRequired,
  isInvalidDomainError: PropTypes.bool,
  isSalesStarter: PropTypes.bool,
  offline: PropTypes.bool,
  activeLocale: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  parentPageHSAnalyticsInfo: PropTypes.instanceOf(Object),
  portalId: PropTypes.number.isRequired,
  profile: PropTypes.instanceOf(UserProfile).isRequired,
  userTimezone: PropTypes.string,
  welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
  formGuid: PropTypes.string,
  linkType: PropTypes.oneOf(valueSeq(LINK_TYPES).toArray()),
  contentTracking: PropTypes.object,
  redirectUrl: PropTypes.string,
  allowRedirect: PropTypes.bool.isRequired,
  userSlug: PropTypes.string,
  isRescheduling: PropTypes.bool,
  meetingChangeId: PropTypes.string,
  meetingRescheduleError: PropTypes.string,
  isPaidMeeting: PropTypes.bool,
  paidMeetingInfo: PropTypes.object,
  paidMeetingPrice: PropTypes.number,
  // action dispatchers
  getAvailability: PropTypes.func.isRequired,
  fetchEventDetails: PropTypes.func.isRequired,
  // request statuses
  bookingPageLoading: PropTypes.bool.isRequired,
  submittingMeeting: PropTypes.bool.isRequired,
  shouldRenderBookingPage: PropTypes.bool.isRequired,
  meetingCreationSuccess: PropTypes.bool.isRequired,
  meetingRescheduleFailed: PropTypes.bool,
  meetingRescheduleSuccess: PropTypes.bool.isRequired,
  fetchBookInfoFailed: PropTypes.bool.isRequired,
  meetingsUserFetchStarted: PropTypes.bool.isRequired,
  meetingsUserFetchSuccess: PropTypes.bool.isRequired,
  meetingCreationFailed: PropTypes.bool.isRequired,
  availabilityFetchFailed: PropTypes.bool.isRequired,
  availabilityFetchSuccess: PropTypes.bool.isRequired,
  initTrackingForMeetings: PropTypes.bool.isRequired,
  // hoc props
  compact: PropTypes.bool
};
App.defaultProps = {
  DatePickerMarker: () => null,
  TimePickerMarker: () => null,
  EmailFormMarker: () => null,
  NotFoundMarker: () => null,
  ErrorMarker: () => null,
  CancelMarker: () => null
};
export default connect(
// @ts-expect-error Jun-23-2025, 19:10UTC fix types
(state, props) => {
  return {
    forceMobile: state.forceMobile,
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    linkType: getBookInfoSelector(state).linkType,
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    formGuid: getBookInfoSelector(state).formGuid,
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    contentTracking: getBookInfoSelector(state).contentTracking,
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    offline: getOfflineSelector(state),
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    branding: props.branding || state.branding,
    portalId: state.portalId,
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    profile: getUserProfileSelector(state, props),
    companyName: state.companyName,
    bookingLifecycle: state.bookingLifecycle,
    userTimezone: state.userTimezone,
    bookInfoError: getBookInfoErrorSelector(state),
    isInvalidDomainError: isInvalidDomainErrorSelector(state),
    initTrackingForMeetings: state.initTrackingForMeetings,
    activeLocale: getActiveLocale(state),
    onSuccess: state.onSuccess,
    onFailure: state.onFailure,
    embedded: state.embedded,
    displayInfo: getDisplayInfoSelector(state, props),
    welcomeScreenInfo: getWelcomeScreenInfoSelector(state),
    /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
    redirectUrl: getCustomParamsSelector(state).redirectUrl,
    allowRedirect: state.allowRedirect,
    isSalesStarter: state.isSalesStarter,
    parentPageHSAnalyticsInfo: state.parentPageHSAnalyticsInfo,
    // request statuses
    meetingCreationSuccess: meetingCreationSuccessSelector(state),
    meetingRescheduleSuccess: meetingRescheduleSuccessSelector(state),
    bookingPageLoading: bookingPageLoadingSelector(state),
    shouldRenderBookingPage: shouldRenderBookingPageSelector(state),
    fetchBookInfoFailed: fetchBookInfoFailedSelector(state),
    meetingCreationFailed: meetingCreationFailedSelector(state),
    meetingRescheduleFailed: meetingRescheduleFailedSelector(state),
    meetingRescheduleError: getRescheduleErrorSelector(state),
    availabilityFetchFailed: availabilityFetchFailedSelector(state),
    availabilityFetchSuccess: availabilityFetchSuccessSelector(state),
    useFullTrackingScript: getIsUngatedForFullTrackingScript(state),
    meetingsUserFetchStarted: meetingsUserFetchStartedSelector(state),
    meetingsUserFetchSuccess: meetingsUserFetchSuccessSelector(state),
    submittingMeeting: isSubmittingMeetingSelector(state),
    isPaidMeeting: getPaidMeetingsAvailableSelector(state),
    paidMeetingInfo: getPaymentLinkInfo(state),
    paidMeetingPrice: getPaidMeetingPrice(state),
    userSlug: state.userSlug,
    isRescheduling: state.isRescheduling,
    meetingChangeId: state.meetingChangeId
  };
}, Object.assign({}, FormActions, BookActions, UIActions, AvailabilityActions) // @ts-expect-error Jun-23-2025, 19:10UTC fix types
)(withConsentListeners(withWindowListeners(App)));